'use client';

import React from 'react';
import FullScreenOverlay from '@/ui/components/shared/FullScreenOverlay';
import { urlParameterCodes } from '@/constants/urlParams';
import { useDirectCartAddition } from '@/ui/hooks/productDetail/useDirectCartAddition';
import AccessoryDetail from '../AccessoryDetail';
import { BundleContextProvider } from '../../../../providers/bundleProvider';
import { Accessory } from '../../../../services/AccessoryService';

export function AccessoryDetailOverlay({
  product,
  initialChooserOpen,
}: Readonly<{
  product: Accessory;
  initialChooserOpen?: boolean;
}>) {
  useDirectCartAddition(product);

  if (!product.showOverlay) {
    return null;
  }

  return (
    <FullScreenOverlay
      paramName={urlParameterCodes.productDetail.chooserOpen}
      initialOpen={initialChooserOpen}
    >
      <BundleContextProvider availableBundles={product.bundles} hostProductId={product.id}>
        <AccessoryDetail accessoryProduct={product} />
      </BundleContextProvider>
    </FullScreenOverlay>
  );
}
